<div class="toaster-notification-container" *ngIf="alerts" #alertDOM>
  <div *ngFor="let alert of alerts">
    <div *ngIf="alert.type === 'danger'" class="custom-alert-danger">
      <span class="content">
        <span><i class="fa fa-exclamation-triangle"></i></span>
        {{ alert.message }}
      </span>
    </div>
    <div *ngIf="alert.type === 'warning'" class="custom-alert-warning">
      <span class="content">
        <span><i class="fa fa-exclamation-triangle"></i></span>
        {{ alert.message }}
      </span>
    </div>
    <div *ngIf="alert.type === 'info'" class="custom-alert-info">
      <span class="content">
        <span><i class="fa fa-check"></i></span>
        {{ alert.message }}
      </span>
    </div>
    <div *ngIf="alert.type === 'success'" class="custom-alert-success">
      <span class="content">
        <span><i class="fa fa-check"></i></span>
        {{ alert.message }}
      </span>
    </div>
  </div>
</div>
